





import { Component, Vue } from 'vue-property-decorator'

/**
 * @title  最大最小值 12 ~ 36
 * @desc 限制最大最小值。
 */
@Component
export default class PrecisionExample extends Vue {
  value: any = null
}
